import React, { FunctionComponent } from 'react'
import { SubstitutionProps } from '../PlayerTypes'
import TeamMemberTemplate from '../template'

const PlayerSubstitution: FunctionComponent<Omit<SubstitutionProps, 'type'>> = ({
    name,
    imageUrl,
    onPressPlayerOut,
    onPressPlayerIn,
    testID,
    substitutionMinute,
    alternatePlayerName,
    alternatePlayerImageUrl,
    showBorderBottom,
}) => {
    return (
        <>
            <TeamMemberTemplate
                name={name}
                testID={testID}
                imageUrl={imageUrl}
                substitutionMinute={substitutionMinute}
                onPressRow={onPressPlayerIn}
                transfer="TRANSFER_IN"
                showBorderTop
                showBorderBottom={false}
            />
            <TeamMemberTemplate
                name={alternatePlayerName}
                testID={testID}
                imageUrl={alternatePlayerImageUrl}
                onPressRow={onPressPlayerOut}
                transfer="TRANSFER_OUT"
                showBorderTop={false}
                showBorderBottom={showBorderBottom}
            />
        </>
    )
}

export default PlayerSubstitution
